<template>
  <transition name="modal" >
    <div class="modal-mask">
    <div class="modal-wrapper" >  
      <div class="modal-container" @click.stop>
        <div class="modal-header">
          <slot name="header">
            {{header}}
          </slot>
        </div>
        <div class="modal-body">
          <slot v-if="!this.error" name="body">
            {{body}}
          </slot>
        </div>
        <el-form style="text-align: center; fontSize: 20px;">
          <el-form-item>
            <el-radio-group v-model="checkIsUSA">
              <el-radio :label="true">US</el-radio>
              <el-radio :label="false">Non-US</el-radio>
            </el-radio-group>
          </el-form-item>
          <span class="error">{{this.error}}</span>
          <el-form-item>
            <button @click="submit($event)" class="modal-default-button">{{ $t('continue') }}</button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
  </transition>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'modal',
  props: ['header', 'body'],
  data() {
    return {
      isVisible: true,
      checkIsUSA: '',
      error: '',
    }
  },
  methods: {
    ...mapMutations('navbar', ['validateRadiusHome', 'validateRadiusPurchase', 'toggleModal', 'resetHomeWithinRadius' ]),
    submit(e) {
      e.preventDefault();
      if (this.checkIsUSA === '') {
        this.error = 'please select one to continue!';
      } else {
        this.error = '';
        this.closeModal();
        this.resetHomeWithinRadius();
      }
    },
    closeModal() {
      // e.preventDefault();
      this.toggleModal(false);
      localStorage.setItem('showModalToken', false);
      localStorage.setItem('isUSA', this.checkIsUSA);
    },
  },
  watch: {
    radiusCheckoutError: function(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        alert(newVal)
      }
    },
    radiusHomeError: function(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        this.body = newVal;
      }
    },
    homeWithinRadius: function(newVal, oldVal) {
      if (newVal === false) {
        this.body = "We are not in your area yet. But we are diligently expanding and look forward to servicing you soon."
        this.error = '';
      }
      if (newVal === true) {
        this.body = "We deliver to your area!";
        this.error = '';
      }
    },
  },
  computed: mapState({
    homeWithinRadius: state => state.navbar.homeWithinRadius,
    homeRadiusChecked: state => state.navbar.homeRadiusChecked,
    checkoutWithinRadius: state => state.navbar.checkoutWithinRadius,
    checkoutRadiusChecked: state => state.navbar.checkoutRadiusChecked,
    radiusCheckoutError: state => state.navbar.radiusCheckoutError,
    radiusHomeError: state => state.navbar.radiusHomeError,
    showModal: state => state.navbar.showModal,
  }), 
}
</script>

<style lang="less">
  @import "../assets/css/modal.less";
</style>



// WEBPACK FOOTER //
// src/view/modal.vue